import React from "react";

import styles from './styles/XStub.module.scss';
export interface IStubProps {
    class?: string | null;
    children? : React.ReactNode;
    height? : string | null;
    width? : string | null;
    flexGrow? : number | null;
    //name:string;
    //optionalParam?:number;
}
export interface IStubState {

}
export class XStub extends React.Component<IStubProps, IStubState>/*<Props, State>*/ {
    // constructor(props: IMainFormProps) {
    //     super(props)
    // }
    render() : React.ReactNode
    {//{React.Children.map(this.props.children, child => <div>{child}</div>)}
        const style = {
            width: this.props.width?? 'auto',
            height: this.props.height?? 'auto',
            flexGrow: this.props.flexGrow?? 1
        }
        return (
            <div className={styles.XStub} style={style}>{this.props.children}</div>
        );
    }
}